export const LOAD_TIRE_DIMS_WIDTHS = "LOAD_TIRE_DIMS_WIDTHS";
export const MOTO_SELECT_WIDTH_DIM = "MOTO_SELECT_WIDTH_DIM";
export const MOTO_SELECT_PROFILE_DIM = "MOTO_SELECT_PROFILE_DIM";
export const MOTO_TIRE_DIMS_PROFILES = "MOTO_TIRE_DIMS_PROFILES";
export const MOTO_TIRE_DIMS_RIMS = "MOTO_TIRE_DIMS_RIMS";
export const MOTO_SELECT_RIM_DIM = "MOTO_SELECT_RIM_DIM";
export const MOTO_RESET_DIMS = "MOTO_RESET_DIMS";
export const MOTO_SELECT_REAR_WIDTH_DIM = "MOTO_SELECT_REAR_WIDTH_DIM";
export const MOTO_SELECT_REAR_PROFILE_DIM = "MOTO_SELECT_REAR_PROFILE_DIM";
export const MOTO_SELECT_REAR_RIM_DIM = "MOTO_SELECT_REAR_RIM_DIM";
export const MOTO_REAR_TIRE_DIMS_PROFILES = "MOTO_REAR_TIRE_DIMS_PROFILES";
export const MOTO_REAR_TIRE_DIMS_RIMS = "MOTO_REAR_TIRE_DIMS_RIMS";
export const MOTO_RESET_REAR_DIMS = "MOTO_RESET_REAR_DIMS";
export const SET_FRONT_TOUCHED = "SET_FRONT_TOUCHED";
export const SET_REAR_TOUCHED = "SET_REAR_TOUCHED";
export const SET_SEARCH_OPEN = "SET_SEARCH_OPEN";
export const LOAD_MOTO_TIRES = "LOAD_MOTO_TIRES";
export const LOAD_MOTO_TIRES_BY_CAT = "LOAD_MOTO_TIRES_BY_CAT";
export const LOAD_MOTO_TIRE_PAIRS = "LOAD_MOTO_TIRE_PAIRS";
export const LOAD_MOTO_TIRE_PAIRS_PENDING = "LOAD_MOTO_TIRE_PAIRS_PENDING";
export const LOAD_TIRES_YEARS = "LOAD_TIRES_YEARS";

export const LOADING = "LOADING";
export const CHECKOUT_ACTIVE_STEP = "CHECKOUT_ACTIVE_STEP";
export const CHECKOUT_RESET_CART_CONDITIONS = "CHECKOUT_RESET_CART_CONDITIONS";

export const BEST_OFFER_SENT = "BEST_OFFER_SENT";
export const TIRE_REQUEST_SENT = "TIRE_REQUEST_SENT";
export const LOAD_PRODUCT = "LOAD_PRODUCT";
export const ADD_PRODUCT_TO_CART = "ADD_PRODUCT_TO_CART";
export const REMOVE_PRODUCT_FROM_CART = "REMOVE_PRODUCT_FROM_CART";
export const CHANGE_PRODUCT_QUANTITY_IN_CART =
  "CHANGE_PRODUCT_QUANTITY_IN_CART";
export const LOAD_INSTALL_CITIES = "LOAD_INSTALL_CITIES";
export const LOAD_SHOPS = "LOAD_SHOPS";
export const LOAD_OPENDATES_FOR_INSTALLATION =
  "LOAD_OPENDATES_FOR_INSTALLATION";
export const LOAD_INSTALL_SLOTS = "LOAD_INSTALL_SLOTS";
export const LOAD_PRODUCT_INFLIGHT = "LOAD_PRODUCT_INFLIGHT";

export const PAYMENT_PAGE_STAGE = "PAYMENT_PAGE_STAGE";

export const LOAD_TOP_SELLERS = "LOAD_TOP_SELLERS";
export const LOAD_POPULAR_SIZES = "LOAD_POPULAR_SIZES";
export const LOAD_POPULAR_TIRE_SETS = "LOAD_POPULAR_TIRE_SETS";

export const RESTORE_CART = "RESTORE_CART";
export const TOGGLE_SNACKBAR = "TOGGLE_SNACKBAR";
export const CART_PRODUCTS_DATA = "CART_PRODUCTS_DATA";
export const FORM_FIELD_CHANGE_PAYMENT = "FORM_FIELD_CHANGE_PAYMENT";
export const FORM_FIELD_CHANGE_PERSONAL = "FORM_FIELD_CHANGE_PERSONAL";
export const FORM_FIELD_CHANGE_SHIPPING = "FORM_FIELD_CHANGE_SHIPPING";
// New for additional notes
export const CHANGE_ADDITIONAL_NOTES = "CHANGE_ADDITIONAL_NOTES";
export const CHECKOUT_ORDER_ERROR = "CHECKOUT_ORDER_ERROR";
export const LOADER_IS_LOADING = "LOADER_IS_LOADING";

export const CHANGE_SIP = "CHANGE_SIP";
export const CHANGE_INSTALL_CITY = "CHANGE_INSTALL_CITY";
export const CHANGE_INSTALL_SHOP = "CHANGE_INSTALL_SHOP";
export const CLEAR_PICK_SHOP = "CLEAR_PICK_SHOP";
export const PICK_INSTALL_DATE = "PICK_INSTALL_DATE";
export const PICK_INSTALL_SLOT = "PICK_INSTALL_SLOT";
export const CHANGE_PAYMENT_METHOD = "CHANGE_PAYMENT_METHOD";
export const COMPLETE_ORDER = "COMPLETE_ORDER";

export const PRODUCT_LIKE = "PRODUCT_LIKE";
export const SHOP_LIKE = "SHOP_LIKE";
export const STATS_UPDATED = "STATS_UPDATED";
export const UPDATE_FILTERS = "UPDATE_FILTERS";

export const LOAD_CITIES_FOR_SHOPS_PAGE = "LOAD_CITIES_FOR_SHOPS_PAGE";
export const PICK_CITY_SHOPS_PAGE = "PICK_CITY_SHOPS_PAGE";
export const LOAD_SHOPS_INDEX_PAGE = "LOAD_SHOPS_INDEX_PAGE";
export const LOAD_SHOP_BY_NAME = "LOAD_SHOP_BY_NAME";

export const ADMIN_LOAD_ORDERS = "ADMIN_LOAD_ORDERS";
export const ADMIN_STATUS_INFLIGHT = "ADMIN_STATUS_INFLIGHT";
export const ADMIN_ORDER_UPDATED = "ADMIN_ORDER_UPDATED";
export const ADMIN_LOAD_ORDER_PAYMENT = "ADMIN_LOAD_ORDER_PAYMENT";
export const WIZARD_USER_ANSWER = "WIZARD_USER_ANSWER";
export const SET_WIZARD_LOADING = "SET_WIZARD_LOADING";
export const SET_WIZARD_STEP = "SET_WIZARD_STEP";
export const RESET_WIZARD = "RESET_WIZARD";
export const SUBMIT_WIZARD_ANSWERS = "SUBMIT_WIZARD_ANSWERS";
export const TAKE_ALL_MOTO_BRANDS_AVAILABLE = "TAKE_ALL_MOTO_BRANDS_AVAILABLE";
export const TAKE_MOTO_LIST_FOR_GPT = "TAKE_MOTO_LIST_FOR_GPT";
export const SUBMIT_USER_BIKE_MODEL_TO_ADD = "SUBMIT_USER_BIKE_MODEL_TO_ADD";
export const SET_USER_MODEL_LOADING = "SET_USER_MODEL_LOADING";
export const SHOW_USER_MODEL_SUCCESS = "SHOW_USER_MODEL_SUCCESS";
export const SET_USER_HAS_SUBMITTED_MODEL = "SET_USER_HAS_SUBMITTED_MODEL";

export const APPLY_COUPON = 'APPLY_COUPON';
export const APPLY_COUPON_ERROR = 'APPLY_COUPON_ERROR';

export const VALIDATE_TIRE_AVAILABILITY_PENDING = 'VALIDATE_TIRE_AVAILABILITY_PENDING';
export const VALIDATE_TIRE_AVAILABILITY_SUCCESS = 'VALIDATE_TIRE_AVAILABILITY_SUCCESS';
export const VALIDATE_TIRE_AVAILABILITY_ERROR = 'VALIDATE_TIRE_AVAILABILITY_ERROR';
export const RESET_TIRE_VALIDATION = 'RESET_TIRE_VALIDATION';

export const LOAD_LIMITED_TIME_OFFERS = 'LOAD_LIMITED_TIME_OFFERS';
export const LOAD_HOMEPAGE_PROMO = 'LOAD_HOMEPAGE_PROMO';

// Deposit cart
export const ADD_TO_DEPOSIT_CART = 'ADD_TO_DEPOSIT_CART';
export const REMOVE_FROM_DEPOSIT_CART = 'REMOVE_FROM_DEPOSIT_CART';
export const UPDATE_DEPOSIT_QUANTITY = 'UPDATE_DEPOSIT_QUANTITY';
export const CLEAR_DEPOSIT_CART = 'CLEAR_DEPOSIT_CART';
export const DEPOSIT_CHECKOUT_ERROR = 'DEPOSIT_CHECKOUT_ERROR';
export const DEPOSIT_CHECKOUT_LOADING = 'DEPOSIT_CHECKOUT_LOADING';
export const DEPOSIT_PREVIEW_LOADED = 'DEPOSIT_PREVIEW_LOADED';
export const DEPOSIT_FINALIZE_RESULT = 'DEPOSIT_FINALIZE_RESULT';
export const DEPOSIT_LOOKUP_RESULT = 'DEPOSIT_LOOKUP_RESULT';
export const DEPOSIT_LOOKUP_LOADING = 'DEPOSIT_LOOKUP_LOADING';
export const DEPOSIT_REMAINDER_FINALIZE_RESULT = 'DEPOSIT_REMAINDER_FINALIZE_RESULT';
